import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues } from './formData';
import { PqrTimeFilter } from '../../../../../shared/types/paramPqrTimes';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';

export const usePqrTimesFilters = (
    onFilter?: (data: PqrTimeFilter) => void
) => {
    const [receptionChannels, setReceptionChannels] = useState<ISelect[]>([]);
    const [typePqr, setTypes] = useState<ISelect[]>([]);
    const [halfs, setHalfs] = useState<ISelect[]>([]);
    const [subtypeDps, setSubtypeDps] = useState<ISelect[]>([]);
    const [procedures, setProcedures] = useState<ISelect[]>([]);
    const [typeDays, setTypeDays] = useState<ISelect[]>([]);
    const [typeTimes, setTypeTimes] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrTimeFilter) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((params) =>
            setReceptionChannels(params)
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) => setTypes(params));
        asyncGetParams(ParamEnum.PQR_PROCEDURE).then((items) =>
            setProcedures(items)
        );
        asyncGetParams(ParamEnum.PQR_STATUS).then((items) =>
            setTypeTimes(items)
        );
        asyncGetParams(ParamEnum.BASE_DATE_FOR_DAY_CALCULATION).then((items) =>
            setTypeDays(items)
        );
        asyncGetLabelParams(ParamEnum.PQR_HALF).then((params) =>
            setHalfs(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(ParamEnum.PQR_SUBTYPE_DP).then((params) =>
            setSubtypeDps(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    return {
        formik,
        receptionChannels,
        halfs,
        subtypeDps,
        procedures,
        typeDays,
        typeTimes,
        typePqr,
    };
};
